import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Separar una cotización por cantidades (fn_separar_cotizacion, 0252): la
 * original se queda con lo que HAY de cada material y nace otra, en la misma
 * orden de servicio, con lo que falta. Las dos viajan a World Office por la
 * cola de siempre; la nueva toma su número allá.
 *
 * Con `facturar`, la original —si el cliente ya la aceptó— queda pedida para
 * FEV en el mismo paso: entra a la cola en cuanto World Office confirme el
 * cambio.
 */
export function useSepararCotizacion() {
  const cliente = useQueryClient()

  return useMutation({
    mutationFn: async ({
      cotizacionId,
      hay,
      facturar,
    }: {
      cotizacionId: string
      /** Cuánto hay de cada material, por id_inventario. */
      hay: Record<string, number>
      facturar: boolean
    }): Promise<string> => {
      const { data, error } = await supabase.rpc('fn_separar_cotizacion', {
        p_cotizacion_id: cotizacionId,
        p_hay: hay,
        p_facturar: facturar,
      })
      if (error) throw new Error(mensajeDeError(error))
      return data as string
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['alistamientos'] })
      await cliente.invalidateQueries({ queryKey: ['ordenes'] })
    },
  })
}
